import React__default from 'react';
import styled, { css } from 'styled-components';
import { COLOR_PALETTE } from '../colors/colorPalette.js';

const StyledSkeleton = styled.span`
  background-color: ${COLOR_PALETTE.slateGrey10};
  background-size: 200px 100%;
  background-repeat: no-repeat;
  border-radius: 0.25rem;
  display: inline-block;
  line-height: 1;
  width: ${(props)=>props.width ? props.width + "rem" : "100%"};
  height: ${(props)=>props.height ? props.height + "rem" : "0.5em"};
  ${(props)=>props.width && props.height && props.circle && css`
      border-radius: 50%;
    `}
`;
/**
 * Skeleton
 * A placeholder with customizable appearance props. Use a Skeleton to stand-in for other components.
 *
 * @param count - number of times to repeat the generated skeleton
 * @param width - width in `rem` units. Defaults to 100%
 * @param height - height in `rem` units. Defaults to 0.5
 * @param circle - display the skeleton with fully rounded corners.
 */ const Skeleton = ({ count =1 , children , ...props })=>{
    const elements = [];
    for(let i = 0; i < count; i++){
        elements.push(React__default.createElement(StyledSkeleton, {
            "data-hpy-web-skeleton": true,
            ...props
        }));
    }
    return React__default.createElement(React__default.Fragment, null, elements);
};
Skeleton.dataId = "data-hpy-web-skeleton";
Skeleton.displayName = "Skeleton";

export { Skeleton };
